import { CognitoUserPool, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import schoolConstants from '../constants/schoolConstants';
import retrieveUser from './retrieveUser';

function authenticateUser(username, password, schoolName) {
  return new Promise((resolve, reject) => {
    var authenticationData = {
      Username: username,
      Password: password,
    };

    var authenticationDetails = new AuthenticationDetails(authenticationData);

    var poolData = {
      UserPoolId: schoolConstants[schoolName].UserPoolId,
      ClientId: schoolConstants[schoolName].ClientId,
    };

    var userPool = new CognitoUserPool(poolData);

    var userData = {
      Username: username,
      Pool: userPool,
    };

    var cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        localStorage.zmailSchoolName = schoolName;
        localStorage.zmailUsername = username;

        retrieveUser(true)
          .then((response) => {
            console.log('in authenticate', response);
            var resolveObj = {
              cognitoUser: cognitoUser,
              type: 'success',
              status: response,
            };
            resolve(resolveObj);
          })
          .catch((err) => {
            var errorMessage = '*' + err.toString().split(':')[1];
            console.error(errorMessage);
            reject(errorMessage);
          });
      },

      onFailure: function (err) {
        var errorMessage = '*' + err.toString().split(':')[1];
        console.error(errorMessage);
        reject(errorMessage);
      },

      newPasswordRequired: function (userAttributes, requiredAttributes) {
        var resolveObj = {
          type: 'newPasswordRequired',
          cognitoUser: cognitoUser,
        };
        resolve(resolveObj);
      },
    });
  });
}

export default authenticateUser;



// WEBPACK FOOTER //
// ./src/authentication/authenticateUser.js